import React from 'react';
import { BuzzBridgeJobDashboard } from '../../BuzzBridge/BuzzBridgeJobDashboard';
import { ContainerWrapper } from '../../ContainerWrapper/ContainerWrapper';

interface IBuzzInterface {}

const BuzzBridgeJobDashboardContainer: React.FC<IBuzzInterface> = props => {
    return (
        /** AppLayout already offsets main by resizable sidebar; skip extra 65px so content stays in the outlet */
        <ContainerWrapper disableLegacyInset>
            <BuzzBridgeJobDashboard />
        </ContainerWrapper>
    );
};

export { BuzzBridgeJobDashboardContainer };
